export default __webpack_public_path__ + "static/media/mapbiomas-partner.102cb8be.png";